<app-layer-list-effect
  (onLayerEnabledChanged)="onLayerEnabledSubject.next($event)"
  [loading]="loadingController.changes | async"
  [distanceLabel]="translationService.getCurrentLanguage()['aggregation'] || 'Agregação'"
  [allowLayerFn]="allowLayerFn"
></app-layer-list-effect>
